// src/main.js
// Suppress benign ResizeObserver loop errors
// Save a reference to the original console.error function
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  // Only if args[0] is a string do we check for our specific substring
  if (
    typeof args[0] === "string" &&
    args[0].includes("ResizeObserver loop completed with undelivered notifications")
  ) {
    return; // Suppress the ResizeObserver error
  }
  // Otherwise, call the original console.error
  resizeObserverErr(...args);
};


import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
//import Particles from "vue3-particles";

import Toast, { PluginOptions } from "vue-toastification";
import "vue-toastification/dist/index.css";

// Import global styles
import './styles/base.scss';
import './styles/theme.scss';

const app = createApp(App);

app.use(router); // Use Vue Router
app.use(store);  // Use Vuex
app.use(vuetify); // Use Vuetify (if used)
app.use(Toast, {
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
});
app.mount('#app');
